import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TodoConstants } from "utils/constants";
//#endregion
//#region components
import { useParams } from "react-router-dom";
import { EntityCardLayout, LoadingSuccess, PageLayouts, Skeletons, useSuccessAnimation } from "components/common";
import TodoNavigation from "./todoItemNavigation";
import TodoViewInner from "./viewInner";
import usePreloadedTodoData from "./usePreload";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import variables from "theme/styles/_variables.module.scss";
import { CSSHelper } from "utils/helpers";

const TodoView: React.FC = () => {
  const urlParams = useParams<EntityIdParams>();
  const pageIndex = Number.parseInt(urlParams.id ?? "0");

  const currentNavigationItems = useSelector(
    (store: AppState) => store.todos.todoNavigationState?.currentNavigationItems
  );
  const numPerPage = useSelector((store: AppState) => store.todos.todoNavigationState?.numPerPage);

  const { preLoadNext } = usePreloadedTodoData();

  const todoCurrentIndex = pageIndex % (numPerPage ?? 0);

  const preLoadNextTodo = (index: number, items: WintSuperkollAPIModel.Todo[]) => {
    const nextIndex = index + 1;
    if (items[nextIndex]) {
      preLoadNext(items[nextIndex]);
    }
  };

  React.useEffect(() => {
    if (pageIndex !== undefined) preLoadNextTodo(todoCurrentIndex, currentNavigationItems ?? []);
  }, [pageIndex]);

  const { showSuccess, onSuccess } = useSuccessAnimation();

  const onBeforeNavigation = () => {
    const topCard = document.getElementById(TodoConstants.TopCardId);
    topCard?.classList.add(cssExports.collapseOut);
  };

  return (
    <PageLayouts.EntityFullScreen
      entityKey={`todo`}
      id={0}
      headerCustomContent={
        <TodoNavigation
          onBeforeNavigation={onBeforeNavigation}
          navigationDelay={CSSHelper.convertMSToNumber(variables.cardNavigationDuration)}
        />
      }
      className={clsx(cssExports.transparent, cssExports.cardNavigation)}
    >
      <>
        {showSuccess ? <LoadingSuccess /> : <></>}
        {currentNavigationItems === undefined ? (
          <EntityCardLayout>
            <Skeletons.EntityCardSkeleton />
          </EntityCardLayout>
        ) : currentNavigationItems[todoCurrentIndex] ? (
          <TodoViewInner todo={currentNavigationItems[todoCurrentIndex]} onSuccess={onSuccess} />
        ) : (
          <></>
        )}
      </>
    </PageLayouts.EntityFullScreen>
  );
};

export default TodoView;
